import React, { useEffect, useState, useRef, memo, createElement } from 'react';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [activeConfession, setActiveConfession] = useState(0);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [isAudio2Playing, setIsAudio2Playing] = useState(false);
  const [isAudio3Playing, setIsAudio3Playing] = useState(false);
  const [isAudio4Playing, setIsAudio4Playing] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const confessionScrollRef = useRef<HTMLDivElement>(null);
  const audioRef = useRef<HTMLAudioElement>(null);
  const audio2Ref = useRef<HTMLAudioElement>(null);
  const audio3Ref = useRef<HTMLAudioElement>(null);
  const audio4Ref = useRef<HTMLAudioElement>(null);
  // Meta Pixel Installation
  useEffect(() => {
    // Meta Pixel Code
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '1366554781441797');
    (window as any).fbq('track', 'PageView');
  }, []);
  // Scroll to top on initial load and remove hash from URL
  useEffect(() => {
    // Remove hash from URL and scroll to top
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname);
    }
    window.scrollTo(0, 0);
  }, []);
  const handleAudioToggle = () => {
    if (audioRef.current) {
      if (isAudioPlaying) {
        audioRef.current.pause();
        setIsAudioPlaying(false);
      } else {
        audioRef.current.play();
        setIsAudioPlaying(true);
      }
    }
  };
  const handleAudio2Toggle = () => {
    if (audio2Ref.current) {
      if (isAudio2Playing) {
        audio2Ref.current.pause();
        setIsAudio2Playing(false);
      } else {
        audio2Ref.current.play();
        setIsAudio2Playing(true);
      }
    }
  };
  const handleAudio3Toggle = () => {
    if (audio3Ref.current) {
      if (isAudio3Playing) {
        audio3Ref.current.pause();
        setIsAudio3Playing(false);
      } else {
        audio3Ref.current.play();
        setIsAudio3Playing(true);
      }
    }
  };
  const handleAudio4Toggle = () => {
    if (audio4Ref.current) {
      if (isAudio4Playing) {
        audio4Ref.current.pause();
        setIsAudio4Playing(false);
      } else {
        audio4Ref.current.play();
        setIsAudio4Playing(true);
      }
    }
  };
  const faqItems = [{
    question: 'Is this about getting my ex back — or moving on?',
    answer: "This guide isn't about forcing an outcome. It's about helping you return to emotional clarity and self-respect. What happens after that often becomes clearer — and healthier — than what you were chasing before."
  }, {
    question: "What if I've already tried everything and nothing worked?",
    answer: 'Most people try harder, not differently. This guide focuses on shifting the emotional dynamic underneath the situation — not adding more effort, pressure, or words.'
  }, {
    question: 'Is this manipulation or psychological tricks?',
    answer: 'No. There are no scripts, games, or tactics here. The focus is on emotional responsibility, dignity, and understanding how attraction naturally responds to safety — not control.'
  }, {
    question: "What if he's already moved on or seeing someone else?",
    answer: "This work isn't about competing or chasing. It's about grounding yourself emotionally so you're no longer defined by someone else's choices — regardless of what they're doing."
  }, {
    question: 'Will this tell me exactly what to say or text?',
    answer: "No. And that's intentional. Instead of scripts, you'll learn how to change the emotional place you're speaking from — so what you say feels natural, calm, and aligned."
  }, {
    question: "What if I'm scared of letting go?",
    answer: "Letting go doesn't mean giving up. Often, it means releasing the version of yourself that's stuck in fear — so you can reconnect from strength instead."
  }, {
    question: 'Is this right for me if I feel emotionally exhausted?',
    answer: "Yes. This guide was created specifically for moments when you're tired of overthinking, analyzing, and trying to hold everything together on your own."
  }, {
    question: 'How soon will I feel a difference?',
    answer: "Many readers describe a shift in perspective almost immediately. The goal isn't speed — it's relief, clarity, and emotional steadiness that lasts."
  }];
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      const cardWidth = 356; // 340px width + 16px gap
      const index = Math.round(scrollLeft / cardWidth);
      setActiveTestimonial(Math.min(Math.max(index, 0), 4));
    }
  };
  const handleConfessionScroll = () => {
    if (confessionScrollRef.current) {
      const scrollLeft = confessionScrollRef.current.scrollLeft;
      const cardWidth = 316; // 300px width + 16px gap
      const index = Math.round(scrollLeft / cardWidth);
      setActiveConfession(Math.min(Math.max(index, 0), 4));
    }
  };
  return <div className="min-h-screen" style={{
    backgroundColor: '#F5F1EC'
  }} data-id="element-0">
      {/* Hero Section */}
      <section className="px-6 py-16 md:py-24" data-id="element-1">
        <div className="max-w-6xl mx-auto" data-id="element-2">
          <div className="flex flex-col lg:flex-row lg:items-center lg:gap-16" data-id="element-3">
            {/* Text Content */}
            <div className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-4">
              <h1 className="mb-6" style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '40px',
              fontWeight: 700,
              fontStyle: 'italic',
              letterSpacing: '-0.5px',
              color: '#2A2A2A',
              lineHeight: '1.2'
            }} data-id="element-5">
                He Still Thinks About You — But Not the Way You Hope
              </h1>

              <p className="mx-auto lg:mx-0" style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '20px',
              fontStyle: 'italic',
              lineHeight: '1.6',
              color: '#585858',
              maxWidth: '550px'
            }} data-id="element-6">
                You feel him slipping away. You replay what you said. You wonder
                what you could've done differently. This is where you find the
                real answer — and reclaim emotional power.
              </p>

              {/* Audio Player */}
              <div onClick={handleAudioToggle} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              backgroundColor: '#F3D6CE',
              color: '#7B4E41',
              borderRadius: '16px',
              padding: '8px 16px',
              boxShadow: '0 4px 12px rgba(243, 214, 206, 0.4)',
              width: '100%',
              maxWidth: '28rem',
              margin: '1rem auto 0',
              cursor: 'pointer',
              transition: 'transform 0.2s ease'
            }} onMouseEnter={e => {
              e.currentTarget.style.transform = 'scale(1.02)';
            }} onMouseLeave={e => {
              e.currentTarget.style.transform = 'scale(1)';
            }} data-id="element-7">
                <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#7B4E41',
                color: 'white',
                flexShrink: 0
              }} data-id="element-8">
                  {isAudioPlaying ? <svg xmlns="http://www.w3.org/2000/svg" style={{
                  width: '16px',
                  height: '16px'
                }} fill="currentColor" viewBox="0 0 16 16" data-id="element-9">
                      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" data-id="element-10" />
                    </svg> : <svg xmlns="http://www.w3.org/2000/svg" style={{
                  width: '16px',
                  height: '16px',
                  marginLeft: '1px'
                }} fill="currentColor" viewBox="0 0 16 16" data-id="element-11">
                      <path d="M5.5 3.5v9l7-4.5-7-4.5z" data-id="element-12" />
                    </svg>}
                </div>
                <span style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '1.3'
              }} data-id="element-13">
                  Don't keep reading until you've heard this →
                </span>
              </div>

              {/* Hidden Audio Element */}
              <audio ref={audioRef} onEnded={() => setIsAudioPlaying(false)} style={{
              opacity: 0,
              pointerEvents: 'none',
              height: 0,
              width: 0,
              position: 'absolute'
            }} data-id="element-14">
                <source src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1768566863/ElevenLabs_2026-01-16T11_42_58_Rachel_pre_sp95_s40_sb75_se0_b_m2_laausj.mp3" type="audio/mpeg" data-id="element-15" />
              </audio>
            </div>

            {/* Image */}
            <div className="flex-1 mt-12 lg:mt-0" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/8oEbfduaJ8oZCDYFGjrEP7/wmremove-transformed.png" alt="Woman in contemplation" className="w-full h-auto rounded-lg shadow-lg" data-id="element-17" />
            </div>
          </div>

          {/* CTA Button - Below Image */}
          <div className="flex justify-center mt-12" data-id="element-18">
            <a href="#offer" onClick={scrollToOffer} style={{
            display: 'inline-block',
            backgroundColor: '#C7654A',
            color: 'white',
            padding: '1rem 2.5rem',
            borderRadius: '10px',
            fontFamily: "'Inter', sans-serif",
            fontWeight: 700,
            textDecoration: 'none',
            fontSize: '1.1rem',
            boxShadow: '0 4px 12px rgba(199, 101, 74, 0.3)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            animation: 'subtlePulse 3s ease-in-out infinite',
            transformOrigin: 'center',
            cursor: 'pointer'
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-19">
              I'm ready to feel emotionally steady again →
            </a>
          </div>
        </div>
      </section>

      {/* The Emotional Mistake Section */}
      <section className="px-6 py-12 md:py-20" style={{
      backgroundColor: '#FBF6F1'
    }} data-id="element-20">
        <div className="max-w-6xl mx-auto" data-id="element-21">
          <div className="flex flex-col lg:flex-row lg:items-center lg:gap-12" data-id="element-22">
            {/* Image - appears below on mobile, left on desktop */}
            <div className="order-2 lg:order-1 lg:flex-1 mt-6 lg:mt-0" data-id="element-23">
              <img src="https://cdn.magicpatterns.com/uploads/j7H8AAM3fzZVm1PBo3Lr65/wmremove-transformed_(1).png" alt="Woman in quiet reflection by window" className="w-full h-auto rounded-lg" data-id="element-24" />

              {/* Second Audio Player - Right after image */}
              <div onClick={handleAudio2Toggle} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              backgroundColor: '#F3D6CE',
              color: '#7B4E41',
              borderRadius: '16px',
              padding: '8px 16px',
              boxShadow: '0 4px 12px rgba(243, 214, 206, 0.4)',
              width: '100%',
              maxWidth: '28rem',
              margin: '1rem auto 0',
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              position: 'relative'
            }} onMouseEnter={e => {
              e.currentTarget.style.transform = 'scale(1.02)';
            }} onMouseLeave={e => {
              e.currentTarget.style.transform = 'scale(1)';
            }} data-id="element-25">
                <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#7B4E41',
                color: 'white',
                flexShrink: 0
              }} data-id="element-26">
                  {isAudio2Playing ? <svg xmlns="http://www.w3.org/2000/svg" style={{
                  width: '16px',
                  height: '16px'
                }} fill="currentColor" viewBox="0 0 16 16" data-id="element-27">
                      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" data-id="element-28" />
                    </svg> : <svg xmlns="http://www.w3.org/2000/svg" style={{
                  width: '16px',
                  height: '16px',
                  marginLeft: '1px'
                }} fill="currentColor" viewBox="0 0 16 16" data-id="element-29">
                      <path d="M5.5 3.5v9l7-4.5-7-4.5z" data-id="element-30" />
                    </svg>}
                </div>
                <div style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
              }} data-id="element-31">
                  <span style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '14px',
                  fontWeight: 500,
                  lineHeight: '1.3'
                }} data-id="element-32">
                    Feel what's been hiding beneath the words →
                  </span>
                </div>

                {/* Hidden Audio Element */}
                <audio ref={audio2Ref} onEnded={() => setIsAudio2Playing(false)} style={{
                opacity: 0,
                pointerEvents: 'none',
                height: 0,
                width: 0,
                position: 'absolute'
              }} data-id="element-33">
                  <source src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1768567443/ElevenLabs_2026-01-16T12_40_28_Rachel_pre_sp95_s40_sb75_se0_b_m2_vjyebg.mp3" type="audio/mpeg" data-id="element-34" />
                </audio>
              </div>
            </div>

            {/* Text Content */}
            <div className="order-1 lg:order-2 lg:flex-1" data-id="element-35">
              <div className="max-w-[640px] mx-auto" data-id="element-36">
                <h2 className="text-center mb-3 md:mb-4" style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '24px',
                fontWeight: 600,
                color: '#2B1F1F',
                lineHeight: '1.3'
              }} data-id="element-37">
                  The Emotional Mistake That Keeps You Powerless
                </h2>

                <p className="text-center mx-auto mb-5 md:mb-8" style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '18px',
                fontStyle: 'italic',
                color: '#705A52',
                lineHeight: '1.5',
                maxWidth: '520px'
              }} data-id="element-38">
                  It's not what you say to him — it's the anxious energy behind
                  it.
                </p>

                <div className="text-center mx-auto" style={{
                fontFamily: "'Lora', serif",
                fontSize: '16px',
                color: '#444444',
                lineHeight: '1.6',
                maxWidth: '520px'
              }} data-id="element-39">
                  <p className="mb-3" data-id="element-40">
                    You think you're just trying to express how you feel.
                  </p>
                  <p className="mb-3" data-id="element-41">
                    But what he hears is pressure, fear, or neediness — even
                    when your words sound calm.
                  </p>
                  <p className="mb-3" data-id="element-42">
                    Why? Because emotion always leaks through.
                  </p>
                  <p className="mb-3" data-id="element-43">
                    This guide was designed to help you shift what he{' '}
                    <em data-id="element-44">feels</em> when he interacts with you — without scripts,
                    without games.
                  </p>
                  <p className="mb-2" data-id="element-45">Before you say anything else…</p>
                  <p style={{
                  fontStyle: 'italic',
                  fontWeight: 500,
                  color: '#2B1F1F'
                }} data-id="element-46">
                    you need to change the emotional place you're speaking from.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Is This the Guide Section */}
      <section className="px-6 py-12 md:py-16" style={{
      backgroundColor: '#F9F4EE'
    }} data-id="element-47">
        <div className="max-w-lg mx-auto" data-id="element-48">
          <h2 className="text-center mb-10" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '22px',
          fontWeight: 700,
          color: '#2B2B2B',
          lineHeight: '1.4'
        }} data-id="element-49">
            Is This the Guide You've Been Needing Without Realizing It?
          </h2>

          <div className="space-y-10" data-id="element-50">
            {/* Yes Card */}
            <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.06)'
          }} data-id="element-51">
              <h3 className="mb-5" style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '20px',
              fontWeight: 600,
              fontStyle: 'italic',
              color: '#504A45'
            }} data-id="element-52">
                Yes, if you…
              </h3>

              <ul className="space-y-3" data-id="element-53">
                {['recently went through a breakup or are in emotional limbo', 'feel displaced, replaced, or confused about your worth', 'swing between wanting him back and wanting yourself back', 'tried everything "right" and still feel invisible', 'want to feel dignified again, not desperate'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-54">
                    <span className="flex-shrink-0 mt-0.5" style={{
                  color: '#77BFA3',
                  fontSize: '18px',
                  fontWeight: 600
                }} data-id="element-55">
                      ✓
                    </span>
                    <span style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '15px',
                  color: '#333333',
                  lineHeight: '1.5'
                }} data-id="element-56">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* No Card */}
            <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.06)'
          }} data-id="element-57">
              <h3 className="mb-5" style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '20px',
              fontWeight: 600,
              fontStyle: 'italic',
              color: '#B05B5B'
            }} data-id="element-58">
                No, if you…
              </h3>

              <ul className="space-y-3" data-id="element-59">
                {['are in a dangerous or abusive relationship', 'expect tricks to manipulate or force him back', "aren't ready to take emotional accountability", 'want quick fixes without internal change', 'are looking for spiritual or purely esoteric advice'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-60">
                    <span className="flex-shrink-0 mt-0.5" style={{
                  color: '#D47C6A',
                  fontSize: '18px',
                  fontWeight: 600
                }} data-id="element-61">
                      ✘
                    </span>
                    <span style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '15px',
                  color: '#4A4A4A',
                  lineHeight: '1.5'
                }} data-id="element-62">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex justify-center mt-12" data-id="element-63">
            <a href="#offer" onClick={scrollToOffer} style={{
            display: 'inline-block',
            backgroundColor: '#C7654A',
            color: 'white',
            padding: '1rem 2.5rem',
            borderRadius: '10px',
            fontFamily: "'Inter', sans-serif",
            fontWeight: 700,
            textDecoration: 'none',
            fontSize: '1.1rem',
            boxShadow: '0 4px 12px rgba(199, 101, 74, 0.3)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            animation: 'subtlePulse 3s ease-in-out infinite',
            transformOrigin: 'center',
            cursor: 'pointer'
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-64">
              Yes — This guide was written for me →
            </a>
          </div>
        </div>
      </section>

      {/* Before & After Section */}
      <section style={{
      backgroundColor: '#FCF7F3',
      padding: '3rem 1.5rem'
    }} data-id="element-65">
        <div style={{
        maxWidth: '20rem',
        margin: '0 auto'
      }} data-id="element-66">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-67">
            <h2 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '24px',
            fontWeight: 700,
            color: '#3B2B26',
            marginBottom: '0.5rem',
            lineHeight: '1.3'
          }} data-id="element-68">
              Before & After: What Changes When You Stop Chasing
            </h2>
            <p style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '15px',
            fontStyle: 'italic',
            color: '#A28E87',
            lineHeight: '1.5'
          }} data-id="element-69">
              From overthinking and invisible, to seen, calm, and magnetic.
            </p>
          </div>

          {/* Card 1: Before - with image inside */}
          <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          marginBottom: '2rem'
        }} data-id="element-70">
            {/* Rose Image at top of card - rounded top corners only */}
            <img src="https://cdn.magicpatterns.com/uploads/iumiJ4gYwXsUHGPY9mMgsY/image.png" alt="Wilted pink rose on soft beige fabric" style={{
            width: '100%',
            height: '120px',
            objectFit: 'cover',
            display: 'block'
          }} data-id="element-71" />

            {/* Card Content */}
            <div style={{
            padding: '20px'
          }} data-id="element-72">
              <h3 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '16px',
              fontStyle: 'italic',
              fontWeight: 500,
              color: '#3B2B26',
              marginBottom: '16px',
              textAlign: 'center'
            }} data-id="element-73">
                Before: The Struggle
              </h3>
              <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }} data-id="element-74">
                {['You overthink every text, afraid of making him pull further away', 'You replay conversations, convinced you said the "wrong thing"', 'You feel anxious, powerless, and stuck in emotional loops'].map((item, index) => <li key={index} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                marginBottom: index < 2 ? '12px' : '0'
              }} data-id="element-75">
                    <span style={{
                  color: '#D1796A',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  lineHeight: '1.5',
                  flexShrink: 0
                }} data-id="element-76">
                      ✘
                    </span>
                    <span style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '15px',
                  color: '#3B2B26',
                  lineHeight: '1.5'
                }} data-id="element-77">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Decorative Divider - floral motif */}
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '1.5rem 0'
        }} data-id="element-78">
            <svg width="100" height="20" viewBox="0 0 100 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-79">
              {/* Líneas laterales delicadas */}
              <line x1="5" y1="10" x2="35" y2="10" stroke="#EECFC7" strokeWidth="1" strokeLinecap="round" data-id="element-80" />
              <line x1="65" y1="10" x2="95" y2="10" stroke="#EECFC7" strokeWidth="1" strokeLinecap="round" data-id="element-81" />

              {/* Pequeños puntos decorativos en los extremos */}
              <circle cx="8" cy="10" r="1" fill="#EECFC7" opacity="0.6" data-id="element-82" />
              <circle cx="92" cy="10" r="1" fill="#EECFC7" opacity="0.6" data-id="element-83" />

              {/* Motivo floral central - pétalos de flor */}
              <circle cx="50" cy="10" r="2.5" fill="none" stroke="#EECFC7" strokeWidth="1" data-id="element-84" />

              {/* Pétalos alrededor del centro */}
              <ellipse cx="50" cy="6" rx="1.5" ry="2.5" fill="#EECFC7" opacity="0.7" data-id="element-85" />
              <ellipse cx="50" cy="14" rx="1.5" ry="2.5" fill="#EECFC7" opacity="0.7" data-id="element-86" />
              <ellipse cx="46" cy="10" rx="2.5" ry="1.5" fill="#EECFC7" opacity="0.7" data-id="element-87" />
              <ellipse cx="54" cy="10" rx="2.5" ry="1.5" fill="#EECFC7" opacity="0.7" data-id="element-88" />

              {/* Pétalos diagonales */}
              <ellipse cx="47" cy="7" rx="1.5" ry="2" fill="#EECFC7" opacity="0.5" transform="rotate(-45 47 7)" data-id="element-89" />
              <ellipse cx="53" cy="7" rx="1.5" ry="2" fill="#EECFC7" opacity="0.5" transform="rotate(45 53 7)" data-id="element-90" />
              <ellipse cx="47" cy="13" rx="1.5" ry="2" fill="#EECFC7" opacity="0.5" transform="rotate(45 47 13)" data-id="element-91" />
              <ellipse cx="53" cy="13" rx="1.5" ry="2" fill="#EECFC7" opacity="0.5" transform="rotate(-45 53 13)" data-id="element-92" />

              {/* Centro de la flor */}
              <circle cx="50" cy="10" r="1.5" fill="#EECFC7" data-id="element-93" />

              {/* Detalles decorativos cerca del centro */}
              <circle cx="40" cy="10" r="0.8" fill="#EECFC7" opacity="0.4" data-id="element-94" />
              <circle cx="60" cy="10" r="0.8" fill="#EECFC7" opacity="0.4" data-id="element-95" />
            </svg>
          </div>

          {/* Card 2: After - with gradient background */}
          <div style={{
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
        }} data-id="element-96">
            {/* Rose Image at top of card */}
            <img src="https://cdn.magicpatterns.com/uploads/5JhvA6Agqrch36xFMDUxdU/image.png" alt="Blooming pink rose on beige fabric" style={{
            width: '100%',
            height: '120px',
            objectFit: 'cover',
            display: 'block'
          }} data-id="element-97" />

            {/* Card Content with gradient background */}
            <div style={{
            background: 'linear-gradient(180deg, #FDEDE9 0%, #F9E0D9 100%)',
            padding: '20px'
          }} data-id="element-98">
              <h3 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '16px',
              fontStyle: 'italic',
              fontWeight: 500,
              color: '#B77670',
              marginBottom: '16px',
              textAlign: 'center'
            }} data-id="element-99">
                After: The Shift
              </h3>
              <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }} data-id="element-100">
                {['You respond with calm, not fear — and feel it inside', "You know conversations aren't auditions for love", "Attraction returns because it's born from emotional safety, not control"].map((item, index) => <li key={index} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                marginBottom: index < 2 ? '12px' : '0'
              }} data-id="element-101">
                    <span style={{
                  color: '#7BA786',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  lineHeight: '1.5',
                  flexShrink: 0
                }} data-id="element-102">
                      ✓
                    </span>
                    <span style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '15px',
                  color: '#3B2B26',
                  lineHeight: '1.5'
                }} data-id="element-103">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* CTA Button */}
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '3rem'
        }} data-id="element-104">
            <a href="#offer" onClick={scrollToOffer} style={{
            display: 'inline-block',
            backgroundColor: '#C7654A',
            color: 'white',
            padding: '1rem 2.5rem',
            borderRadius: '10px',
            fontFamily: "'Inter', sans-serif",
            fontWeight: 700,
            textDecoration: 'none',
            fontSize: '1.1rem',
            boxShadow: '0 4px 12px rgba(199, 101, 74, 0.3)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            animation: 'subtlePulse 3s ease-in-out infinite',
            transformOrigin: 'center',
            cursor: 'pointer'
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-105">
              I want that shift. Show me how →
            </a>
          </div>
        </div>
      </section>

      {/* Subtle Authority Section */}
      <section style={{
      backgroundColor: '#F7F1EB',
      padding: '4rem 1.5rem',
      position: 'relative',
      overflow: 'hidden'
    }} data-id="element-106">
        {/* Subtle background texture */}
        <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.03,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%234C3A32' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        pointerEvents: 'none'
      }} data-id="element-107" />

        <div style={{
        maxWidth: '60ch',
        margin: '0 auto',
        textAlign: 'center',
        position: 'relative'
      }} data-id="element-108">
          {/* Headline */}
          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '22px',
          fontWeight: 500,
          color: '#4C3A32',
          marginBottom: '0.75rem',
          lineHeight: '1.4'
        }} data-id="element-109">
            Crafted from Real Emotional Patterns — Not Guesswork
          </h2>

          {/* Subheadline */}
          <p style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '17px',
          fontStyle: 'italic',
          color: '#A49B94',
          marginBottom: '2rem',
          lineHeight: '1.5'
        }} data-id="element-110">
            Because this isn't about tricks. It's about truth.
          </p>

          {/* Body Text */}
          <div style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: '16px',
          color: '#7A6F67',
          lineHeight: '1.7',
          animation: 'fadeIn 0.8s ease-in'
        }} data-id="element-111">
            <p style={{
            marginBottom: '1rem'
          }} data-id="element-112">
              This guide wasn't built in theory — it emerged from observing the
              emotional dynamics of over 1,000 women navigating breakups,
              longing, and limbo.
            </p>
            <p style={{
            marginBottom: '1rem'
          }} data-id="element-113">
              What they shared, what they wished they had said differently, what
              worked (and what didn't).
            </p>
            <p style={{
            margin: 0
          }} data-id="element-114">
              That's what shaped this.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section style={{
      backgroundColor: '#FDF8F5',
      padding: '4rem 1.5rem'
    }} data-id="element-115">
        <div style={{
        maxWidth: '700px',
        margin: '0 auto'
      }} data-id="element-116">
          {/* Section Title */}
          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '26px',
          fontWeight: 700,
          color: '#3F2A24',
          textAlign: 'center',
          marginBottom: '2.25rem'
        }} data-id="element-117">
            What Our Readers Are Saying
          </h2>

          {/* Third Audio Player - Below title */}
          <div onClick={handleAudio3Toggle} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          backgroundColor: '#F3D6CE',
          color: '#7B4E41',
          borderRadius: '16px',
          padding: '8px 16px',
          boxShadow: '0 4px 12px rgba(243, 214, 206, 0.4)',
          width: '100%',
          maxWidth: '28rem',
          margin: '0 auto 2.25rem',
          cursor: 'pointer',
          transition: 'transform 0.2s ease',
          position: 'relative'
        }} onMouseEnter={e => {
          e.currentTarget.style.transform = 'scale(1.02)';
        }} onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
        }} data-id="element-118">
            <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: '#7B4E41',
            color: 'white',
            flexShrink: 0
          }} data-id="element-119">
              {isAudio3Playing ? <svg xmlns="http://www.w3.org/2000/svg" style={{
              width: '16px',
              height: '16px'
            }} fill="currentColor" viewBox="0 0 16 16" data-id="element-120">
                  <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" data-id="element-121" />
                </svg> : <svg xmlns="http://www.w3.org/2000/svg" style={{
              width: '16px',
              height: '16px',
              marginLeft: '1px'
            }} fill="currentColor" viewBox="0 0 16 16" data-id="element-122">
                  <path d="M5.5 3.5v9l7-4.5-7-4.5z" data-id="element-123" />
                </svg>}
            </div>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
          }} data-id="element-124">
              <span style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '1.3'
            }} data-id="element-125">
                Listen to how this felt…
              </span>
            </div>

            {/* Hidden Audio Element */}
            <audio ref={audio3Ref} onEnded={() => setIsAudio3Playing(false)} style={{
            opacity: 0,
            pointerEvents: 'none',
            height: 0,
            width: 0,
            position: 'absolute'
          }} data-id="element-126">
              <source src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1768568615/ElevenLabs_2026-01-16T13_02_59_River_-_Relaxed_Neutral_Informative_pre_sp95_s41_sb75_se0_b_m2_gyqf1p.mp3" type="audio/mpeg" data-id="element-127" />
            </audio>
          </div>

          {/* Testimonial Carousel Container */}
          <div ref={scrollContainerRef} onScroll={handleScroll} style={{
          overflowX: 'auto',
          scrollSnapType: 'x mandatory',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          marginBottom: '1.5rem'
        }} className="testimonial-slider" data-id="element-128">
            <div style={{
            display: 'flex',
            gap: '16px',
            paddingBottom: '1rem'
          }} data-id="element-129">
              {/* Testimonial 1 - Emma */}
              <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '20px',
              boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
              padding: '24px',
              minWidth: '340px',
              maxWidth: '340px',
              textAlign: 'center',
              scrollSnapAlign: 'center',
              flexShrink: 0
            }} data-id="element-130">
                <img src="https://i.pravatar.cc/120?img=47" alt="Emma" style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                margin: '0 auto 12px',
                objectFit: 'cover'
              }} data-id="element-131" />
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '12px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#8D746B',
                marginBottom: '10px'
              }} data-id="element-132">
                  A Quiet Shift That Changed Everything
                </p>
                <blockquote style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '19px',
                fontWeight: 600,
                lineHeight: '1.4',
                color: '#2F1C17',
                marginBottom: '8px'
              }} data-id="element-133">
                  "I was stuck replaying every message, afraid of saying the
                  wrong thing. This didn't teach me what to say — it changed how
                  I felt. That's when everything shifted."
                </blockquote>
                <p style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '14px',
                fontStyle: 'italic',
                color: '#7A6258',
                marginTop: '8px',
                marginBottom: '12px'
              }} data-id="element-134">
                  — Emma, 32
                </p>
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#6E5E58'
              }} data-id="element-135">
                  She didn't stop caring — she stopped abandoning herself.
                  That's what created emotional safety and quiet attraction.
                </p>
              </div>

              {/* Testimonial 2 - Sophia */}
              <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '20px',
              boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
              padding: '24px',
              minWidth: '340px',
              maxWidth: '340px',
              textAlign: 'center',
              scrollSnapAlign: 'center',
              flexShrink: 0
            }} data-id="element-136">
                <img src="https://i.pravatar.cc/120?img=32" alt="Sophia" style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                margin: '0 auto 12px',
                objectFit: 'cover'
              }} data-id="element-137" />
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '12px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#8D746B',
                marginBottom: '10px'
              }} data-id="element-138">
                  Finally, I Felt Seen
                </p>
                <blockquote style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '19px',
                fontWeight: 600,
                lineHeight: '1.4',
                color: '#2F1C17',
                marginBottom: '8px'
              }} data-id="element-139">
                  "I thought I was crazy for feeling so much. This made me feel
                  human again — and strong."
                </blockquote>
                <p style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '14px',
                fontStyle: 'italic',
                color: '#7A6258',
                marginTop: '8px',
                marginBottom: '12px'
              }} data-id="element-140">
                  — Sophia, 39
                </p>
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#6E5E58'
              }} data-id="element-141">
                  Every word gave me permission to feel without guilt. That's
                  when I started healing.
                </p>
              </div>

              {/* Testimonial 3 - Mia */}
              <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '20px',
              boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
              padding: '24px',
              minWidth: '340px',
              maxWidth: '340px',
              textAlign: 'center',
              scrollSnapAlign: 'center',
              flexShrink: 0
            }} data-id="element-142">
                <img src="https://i.pravatar.cc/120?img=45" alt="Mia" style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                margin: '0 auto 12px',
                objectFit: 'cover'
              }} data-id="element-143" />
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '12px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#8D746B',
                marginBottom: '10px'
              }} data-id="element-144">
                  From Panic to Peace
                </p>
                <blockquote style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '19px',
                fontWeight: 600,
                lineHeight: '1.4',
                color: '#2F1C17',
                marginBottom: '8px'
              }} data-id="element-145">
                  "I used to panic every time he didn't reply. Now I understand
                  why — and I finally feel calm."
                </blockquote>
                <p style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '14px',
                fontStyle: 'italic',
                color: '#7A6258',
                marginTop: '8px',
                marginBottom: '12px'
              }} data-id="element-146">
                  — Mia, 28
                </p>
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#6E5E58'
              }} data-id="element-147">
                  This helped me stop spiraling and start choosing myself.
                </p>
              </div>

              {/* Testimonial 4 - Aisha */}
              <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '20px',
              boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
              padding: '24px',
              minWidth: '340px',
              maxWidth: '340px',
              textAlign: 'center',
              scrollSnapAlign: 'center',
              flexShrink: 0
            }} data-id="element-148">
                <img src="https://i.pravatar.cc/120?img=26" alt="Aisha" style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                margin: '0 auto 12px',
                objectFit: 'cover'
              }} data-id="element-149" />
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '12px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#8D746B',
                marginBottom: '10px'
              }} data-id="element-150">
                  The Mirror I Needed
                </p>
                <blockquote style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '19px',
                fontWeight: 600,
                lineHeight: '1.4',
                color: '#2F1C17',
                marginBottom: '8px'
              }} data-id="element-151">
                  "This wasn't just about him. It was about me seeing myself
                  clearly — for the first time."
                </blockquote>
                <p style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '14px',
                fontStyle: 'italic',
                color: '#7A6258',
                marginTop: '8px',
                marginBottom: '12px'
              }} data-id="element-152">
                  — Aisha, 35
                </p>
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#6E5E58'
              }} data-id="element-153">
                  I thought I wanted him back, but what I really needed was to
                  come back to myself.
                </p>
              </div>

              {/* Testimonial 5 - Julia */}
              <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '20px',
              boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
              padding: '24px',
              minWidth: '340px',
              maxWidth: '340px',
              textAlign: 'center',
              scrollSnapAlign: 'center',
              flexShrink: 0
            }} data-id="element-154">
                <img src="https://i.pravatar.cc/120?img=44" alt="Julia" style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                margin: '0 auto 12px',
                objectFit: 'cover'
              }} data-id="element-155" />
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '12px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#8D746B',
                marginBottom: '10px'
              }} data-id="element-156">
                  Clarity, Finally
                </p>
                <blockquote style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '19px',
                fontWeight: 600,
                lineHeight: '1.4',
                color: '#2F1C17',
                marginBottom: '8px'
              }} data-id="element-157">
                  "After reading this, I stopped begging for crumbs. I
                  remembered who I was."
                </blockquote>
                <p style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '14px',
                fontStyle: 'italic',
                color: '#7A6258',
                marginTop: '8px',
                marginBottom: '12px'
              }} data-id="element-158">
                  — Julia, 40
                </p>
                <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '14px',
                lineHeight: '1.6',
                color: '#6E5E58'
              }} data-id="element-159">
                  I went from feeling powerless to powerful — not because of
                  him, but because of me.
                </p>
              </div>
            </div>
          </div>

          {/* Dots Navigation */}
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '8px'
        }} data-id="element-160">
            {[0, 1, 2, 3, 4].map(index => <div key={index} style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: index === activeTestimonial ? '#C7654A' : '#D4C4BA',
            transition: 'background-color 0.3s ease'
          }} data-id="element-161" />)}
          </div>
        </div>
      </section>

      {/* FAQ Section */}

      {/* Micro-Confessions Section */}

      {/* Offer Section - Mobile First Editorial */}
      <section id="offer" style={{
      backgroundColor: '#F9F4EE',
      padding: '3rem 1.5rem'
    }} data-id="element-162">
        <div style={{
        maxWidth: '600px',
        margin: '0 auto'
      }} data-id="element-163">
          {/* Main Product Image */}
          <div style={{
          textAlign: 'center',
          marginBottom: '2rem'
        }} data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/9qAJbhMm1MF5atvEL3FMTQ/nano_banana_removed.png" alt="21 Emotional Triggers That Make Your Ex See You as the One That Got Away" style={{
            maxWidth: '100%',
            width: '320px',
            borderRadius: '12px',
            boxShadow: '0 12px 28px rgba(0, 0, 0, 0.12)',
            margin: '0 auto',
            display: 'block'
          }} data-id="element-165" />
          </div>

          {/* Title & Subtitle */}
          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '1.85rem',
          fontWeight: 700,
          color: '#4B2F2F',
          textAlign: 'center',
          marginBottom: '0.5rem',
          lineHeight: '1.3'
        }} data-id="element-166">
            Your Complete Emotional Shift Package
          </h2>

          <p style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '1rem',
          fontStyle: 'italic',
          color: '#6E5B50',
          textAlign: 'center',
          marginBottom: '1.5rem'
        }} data-id="element-167">
            Main Guide + Bonus Included
          </p>

          {/* Price Block */}
          <div style={{
          textAlign: 'center',
          marginBottom: '2rem'
        }} data-id="element-168">
            <p style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            color: '#C7654A',
            margin: '0',
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-169">
              Only $17
              <span style={{
              fontSize: '1.25rem',
              color: '#999',
              textDecoration: 'line-through',
              marginLeft: '0.5rem',
              fontWeight: 400
            }} data-id="element-170">
                $47
              </span>
            </p>
            <p style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '0.75rem',
            color: '#7A5D51',
            textTransform: 'uppercase',
            letterSpacing: '0.8px',
            marginTop: '0.25rem',
            fontWeight: 600
          }} data-id="element-171">
              Limited Time Intro Price
            </p>
          </div>

          {/* Value Bullets */}
          <div style={{
          textAlign: 'left',
          marginBottom: '2rem',
          padding: '0 1rem'
        }} data-id="element-172">
            {['Interrupt the anxious spiral — feel calm, secure, and grounded in your worth', 'End the self-blame loop — understand why he pulled away without making it personal', 'Reconnect from strength, not fear — stop chasing while still creating emotional pull'].map((item, index) => <p key={index} style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '1rem',
            color: '#453A36',
            lineHeight: '1.7',
            marginBottom: '0.75rem',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.75rem'
          }} data-id="element-173">
                <span style={{
              color: '#C7654A',
              fontSize: '1.25rem',
              fontWeight: 600
            }} data-id="element-174">
                  ✓
                </span>
                <span data-id="element-175">{item}</span>
              </p>)}
          </div>

          {/* CTA Button */}
          <div style={{
          textAlign: 'center',
          marginBottom: '1rem'
        }} data-id="element-176">
            {/* Fourth Audio Player - Above CTA button */}
            <div onClick={handleAudio4Toggle} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            backgroundColor: '#F3D6CE',
            color: '#7B4E41',
            borderRadius: '16px',
            padding: '8px 16px',
            boxShadow: '0 4px 12px rgba(243, 214, 206, 0.4)',
            width: '100%',
            maxWidth: '28rem',
            margin: '0 auto 1.5rem',
            cursor: 'pointer',
            transition: 'transform 0.2s ease',
            position: 'relative'
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.02)';
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-177">
              <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              backgroundColor: '#7B4E41',
              color: 'white',
              flexShrink: 0
            }} data-id="element-178">
                {isAudio4Playing ? <svg xmlns="http://www.w3.org/2000/svg" style={{
                width: '16px',
                height: '16px'
              }} fill="currentColor" viewBox="0 0 16 16" data-id="element-179">
                    <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" data-id="element-180" />
                  </svg> : <svg xmlns="http://www.w3.org/2000/svg" style={{
                width: '16px',
                height: '16px',
                marginLeft: '1px'
              }} fill="currentColor" viewBox="0 0 16 16" data-id="element-181">
                    <path d="M5.5 3.5v9l7-4.5-7-4.5z" data-id="element-182" />
                  </svg>}
              </div>
              <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%'
            }} data-id="element-183">
                <span style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '1.3'
              }} data-id="element-184">
                  Let this be the moment it all starts to shift →
                </span>
              </div>

              {/* Hidden Audio Element */}
              <audio ref={audio4Ref} onEnded={() => setIsAudio4Playing(false)} style={{
              opacity: 0,
              pointerEvents: 'none',
              height: 0,
              width: 0,
              position: 'absolute'
            }} data-id="element-185">
                <source src="https://res.cloudinary.com/dd0wtuekk/video/upload/v1768569448/ElevenLabs_2026-01-16T13_16_39_River_-_Relaxed_Neutral_Informative_pre_sp95_s41_sb75_se0_b_m2_gxhjo6.mp3" type="audio/mpeg" data-id="element-186" />
              </audio>
            </div>

            <a href="#checkout" style={{
            display: 'inline-block',
            backgroundColor: '#C7654A',
            color: 'white',
            padding: '1rem 2.5rem',
            borderRadius: '10px',
            fontFamily: "'Inter', sans-serif",
            fontWeight: 700,
            textDecoration: 'none',
            fontSize: '1.1rem',
            boxShadow: '0 4px 12px rgba(199, 101, 74, 0.3)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            animation: 'subtlePulse 3s ease-in-out infinite',
            transformOrigin: 'center'
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-187">
              Yes, I want emotional clarity →
            </a>
          </div>

          <p style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '0.9rem',
          fontStyle: 'italic',
          color: '#7A5D51',
          textAlign: 'center',
          marginBottom: '3rem'
        }} data-id="element-188">
            Instant digital download — Start today.
          </p>

          {/* Bonus Section - Framed */}
          <div style={{
          backgroundColor: '#F2DFDD',
          padding: '2rem 1.5rem',
          borderRadius: '16px',
          boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.06)',
          border: '1px solid rgba(199, 101, 74, 0.1)'
        }} data-id="element-189">
            {/* Bonus Headline */}
            <h3 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '1.5rem',
            fontWeight: 700,
            color: '#8E5A52',
            textAlign: 'center',
            marginBottom: '1.5rem'
          }} data-id="element-190">
              FREE Bonus Included
            </h3>

            {/* Bonus Image */}
            <div style={{
            textAlign: 'center',
            marginBottom: '1.5rem'
          }} data-id="element-191">
              <img src="https://cdn.magicpatterns.com/uploads/g4uuTt4RWjqeKxdLv1J6jZ/nano_banana_removed_(1).png" alt="The 7 Phrases That Destroy Any Chance of Getting Your Ex Back" style={{
              maxWidth: '100%',
              width: '260px',
              borderRadius: '10px',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
              margin: '0 auto',
              display: 'block'
            }} data-id="element-192" />
            </div>

            {/* Bonus Description */}
            <div style={{
            textAlign: 'center'
          }} data-id="element-193">
              <h4 style={{
              fontFamily: "'Lora', serif",
              fontSize: '1.15rem',
              fontWeight: 600,
              color: '#4A2E2A',
              marginBottom: '0.75rem',
              lineHeight: '1.4'
            }} data-id="element-194">
                The 7 Phrases That Destroy Any Chance of Getting Your Ex Back
              </h4>

              <p style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '0.95rem',
              color: '#5A4A45',
              lineHeight: '1.6',
              marginBottom: '0.5rem'
            }} data-id="element-195">
                Know exactly what <em data-id="element-196">not</em> to say when emotions run high.
              </p>

              <p style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '0.95rem',
              color: '#5A4A45',
              lineHeight: '1.6',
              marginBottom: '1rem'
            }} data-id="element-197">
                Includes a real-time emotional filter tool — not scripts.
              </p>

              {/* Bonus Price */}
              <p style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '1rem',
              color: '#8E5A52',
              fontWeight: 600
            }} data-id="element-198">
                <span style={{
                textDecoration: 'line-through',
                color: '#999',
                marginRight: '0.5rem'
              }} data-id="element-199">
                  Was $29
                </span>
                <span style={{
                color: '#C7654A',
                fontWeight: 700
              }} data-id="element-200">
                  Now FREE
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="px-6 py-12 border-t" style={{
      borderColor: '#E8D5C4'
    }} data-id="element-201">
        <div className="max-w-4xl mx-auto text-center" data-id="element-202">
          <p style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '16px',
          color: '#585858'
        }} data-id="element-203">
            © 2024 Emotional Repositioning Guide. All rights reserved.
          </p>
        </div>
      </footer>

      {/* Floating Social Proof Popup */}
      <SocialProofPopup data-id="element-204" />
    </div>;
}